import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ClockIcon, MapPinIcon, SunIcon, UtensilsIcon, WalletIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { vacancies } from '../data/vacancies';
import { clinic, images } from '../data/clinic';

/** Benefits that recur in every vacancy text. */
const perks = [{
  icon: SunIcon,
  title: 'Dagdienst',
  text: 'Werken in dagdienst, met een goede balans tussen werk en privé.'
}, {
  icon: WalletIcon,
  title: 'Cao Ziekenhuizen',
  text: 'Pensioenregeling, 8,33% vakantietoeslag en 8,33% eindejaarsuitkering.'
}, {
  icon: UtensilsIcon,
  title: 'Lunch & reiskosten',
  text: 'Dagelijks een aangeboden lunch en € 0,25 per kilometer reiskosten.'
}];
export function Vacancies() {
  return <>
      <PageHeader title="Werken bij Excellent Care Clinics" crumbs={[{
      label: 'Over ons',
      to: '/over-ons'
    }, {
      label: 'Vacatures'
    }]} intro="Een kleinschalige, gespecialiseerde pijnkliniek in Velsen-Noord. De lijnen zijn kort, jouw bijdrage is zichtbaar en er is ruimte om mee te denken over kwaliteit en verbetering van zorg." data-id="element-867" data-mp="2yck1bs5v6wtg" />

      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20" data-id="element-868" data-mp="1x2r59go152ou">
        <div className="flex items-end justify-between gap-4" data-id="element-869" data-mp="2avql5jrq4ywx">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-870" data-mp="25wngi0fnouph">Openstaande vacatures</h2>
          <span className="text-sm text-muted" data-id="element-871" data-mp="1i8cid51ch94w">{vacancies.length} functies</span>
        </div>
        <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-872" data-mp="1e7123q4d209d">
          {vacancies.map(v => <li key={v.slug} data-id="element-873" data-mp="1s6jxdic2ph49">
              <Link to={`/vacatures/${v.slug}`} className="group grid gap-3 py-7 transition-colors duration-150 md:grid-cols-[1.2fr_1fr_auto] md:items-center md:gap-10" data-id="element-874" data-mp="1s3o261rm16ji">
                <span data-id="element-875" data-mp="2ylt6lh14v6mk">
                  <span className="block font-display text-xl font-semibold text-ink group-hover:text-primary sm:text-2xl" data-id="element-876" data-mp="2ymm8a3l8j5xu">{v.title}</span>
                  <span className="mt-1.5 block text-[15px] leading-relaxed text-muted" data-id="element-877" data-mp="36m91644bjtda">{v.lead}</span>
                </span>
                <span className="flex flex-wrap gap-x-5 gap-y-1.5 text-sm text-muted" data-id="element-878" data-mp="3apykae285iqx">
                  <span className="flex items-center gap-1.5" data-id="element-879" data-mp="3fl4a3nyqzhka">
                    <ClockIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-880" data-mp="3kkyz1lyypx2p" />
                    {v.hours}
                  </span>
                  <span className="flex items-center gap-1.5" data-id="element-881" data-mp="2mwosqus58n5s">
                    <MapPinIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-882" data-mp="2rye46bja32ue" />
                    {clinic.city}
                  </span>
                </span>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-soft text-primary transition-colors duration-150 group-hover:bg-primary group-hover:text-white" data-id="element-883" data-mp="31nxs3vlulmw4">
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-884" data-mp="296lcckfy3no9" />
                </span>
              </Link>
            </li>)}
        </ul>
      </section>

      <section className="border-t border-line bg-surface" data-id="element-885" data-mp="21l9dc8a77xv0">
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-2 lg:items-center lg:gap-20 lg:px-8 lg:py-20" data-id="element-886" data-mp="1wp286hpmmqe4">
          <img src={images.procedure} alt="Behandelkamer van Excellent Care Clinics" className="aspect-[4/3] w-full rounded-3xl object-cover" data-id="element-887" data-mp="1rritxhsxidm6" />
          <div data-id="element-888" data-mp="1iozt138peb2k">
            <h2 className="font-display text-3xl font-semibold tracking-tight text-ink" data-id="element-889" data-mp="1ipjcwphwz9j8">Wat wij bieden</h2>
            <ul className="mt-8 space-y-7" data-id="element-890" data-mp="1dx9hwv1xzja3">
              {perks.map(({
              icon: Icon,
              title,
              text
            }) => <li key={title} className="flex gap-4" data-id="element-891" data-mp="18zg7tqxiq54j">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-primary ring-1 ring-line" data-id="element-892" data-mp="140deh3qwhnce">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-893" data-mp="z08zji5n50oa" />
                  </span>
                  <span data-id="element-894" data-mp="v0go8xov4gf8">
                    <span className="block font-display text-lg font-semibold text-ink" data-id="element-895" data-mp="v19ttvc34zvs">{title}</span>
                    <span className="mt-1 block text-[15px] leading-relaxed text-muted" data-id="element-896" data-mp="1jrw95cgpqco5">{text}</span>
                  </span>
                </li>)}
            </ul>
            <p className="mt-10 text-[15px] text-muted" data-id="element-897" data-mp="1awzrrwmu9tp7">
              Vragen? Mail naar{' '}
              <a href="mailto:vacature@excellentcareclinics.nl" className="font-medium text-primary hover:underline" data-id="element-898" data-mp="1exjox07ewxbc">
                vacature@excellentcareclinics.nl
              </a>
            </p>
          </div>
        </div>
      </section>
    </>;
}